import { Close, DeleteForeverSharp, ReplaySharp, Save } from '@mui/icons-material';
import {
    Button,
    IconButton,
    AppBar,
    Dialog,
    Stack,
    Toolbar,
} from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import EllipsisTypography from '../../components/EllipsisTypography';
import {
    RichTextEditorComponent,
    HtmlEditor,
    Inject,
    Toolbar as RTE_Toolbar,
    Image,
    Link,
    QuickToolbar,
} from '@syncfusion/ej2-react-richtexteditor';
import { updateSystemAnnouncementByKey } from '../../apis/systemAnnouncementApis';
import Loader from '../ContractDetails/Components/Loader';
import { RICH_TEXT_EDITOR_TOOLBAR_SETTINGS } from '../../_constants';

const EditAndPreview = ({ editAndPreviewMessage, setEditAndPreviewMessage, onSuccess ,loading,systemAnnouncementData }) => {
    const { t } = useTranslation();
    const editorRef = useRef(null);

    useEffect(() => {
        if (editorRef.current) {
            editorRef.current.value = editAndPreviewMessage?.data || "";
        }
    }, [editAndPreviewMessage]);
  
    const handleSave = async () => {
        const htmlContent = editorRef.current?.getHtml() || "";
        await updateSystemAnnouncementByKey([
            { id: 'message', name: htmlContent },
        ]);
        onSuccess();
        setEditAndPreviewMessage({ open: false, data: null, });
    };

    const handleDeleteBtn = () => {
        if (editorRef.current) {
            editorRef.current.value = "";
        }
        setEditAndPreviewMessage({ open: true, data: '',});
    };

    const handleRestoreBtn = () => {

        if (editorRef.current) {
            editorRef.current.value = systemAnnouncementData?.message || "";
        }
    };

    return (
        <> {loading && <Loader backdrop={true} />}
        
         <Dialog
            fullScreen
            open={editAndPreviewMessage.open}
            onClose={() =>
                setEditAndPreviewMessage({ open: false, data: null, })
            }
        >
            <AppBar position="relative">
                <Toolbar>
                    <Stack direction="row" width="100%" justifyContent="space-between">
                        <Stack direction="row" alignItems="center">
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() =>
                                    setEditAndPreviewMessage({
                                        open: false,
                                        data: null,
                                    })
                                }
                            >
                                <Close />
                            </IconButton>
                            <EllipsisTypography
                                component="div"
                                variant="h6"
                                sx={{ ml: 2 }}
                                title={t("general.message")}
                            />
                        </Stack>

                        <Stack direction="row" spacing={1}>
                                <Button
                                    sx={{ display: { xs: 'none', sm: 'inline-flex' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}
                                    size='small'
                                    variant="text"
                                    color='inherit'
                                    startIcon={<DeleteForeverSharp />}
                                    onClick={handleDeleteBtn}
                                >
                                    {t("general.delete")}
                                </Button>
                                <Button  size='small' onClick={handleRestoreBtn} sx={{ display: { xs: 'none', sm: 'inline-flex' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }} color='inherit' startIcon={<ReplaySharp />}>
                                    {t('general.restore')}
                                </Button>
                              <Button
                                 sx={{ display: { xs: 'none', sm: 'inline-flex' }, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', }}
                                    size='small'
                                    variant="text"
                                    color='inherit'
                                startIcon={<Save />}
                                onClick={handleSave}
                               >
                                {t("general.save")}
                              </Button>
                                <IconButton
                                    sx={{ display: { sm: "none" } }}
                                    color='inherit'
                                    onClick={handleDeleteBtn}
                                >
                                    <DeleteForeverSharp />
                                </IconButton>
                                <IconButton
                                    sx={{ display: { sm: "none" } }}
                                    color='inherit'
                                    onClick={handleRestoreBtn}
                                >
                                    <ReplaySharp />
                                </IconButton>
                                <IconButton
                                    sx={{ display: { sm: "none" } }}
                                    color='inherit'
                                    onClick={handleSave}
                                >
                                    <Save />
                                </IconButton>
                        </Stack>
                    </Stack>
                </Toolbar>
            </AppBar>

            <RichTextEditorComponent
                ref={editorRef}
                height="100%"
                width="100%"
                value={editAndPreviewMessage?.data || ""}
                toolbarSettings={RICH_TEXT_EDITOR_TOOLBAR_SETTINGS}
                insertImageSettings={{ saveFormat: "Base64" }}
            >
                <Inject
                    services={[HtmlEditor, RTE_Toolbar, Image, Link, QuickToolbar]}
                />
            </RichTextEditorComponent>
        </Dialog>
        </>
       
    );
};

export default EditAndPreview;
